<template>
  <div :class="classes">
      <pt-page-title title="重采待处理订单">
            <!-- <el-button slot="before-left" type="primary" @click="exportResampleOrder" :loading="exportLoading">导出</el-button> -->
      </pt-page-title>
      <pt-page-menu-filter :tabs="tabs" v-model="selectTab"></pt-page-menu-filter>
      <!-- <pt-page-factor-filter :labels="sampleRecollectFilterFactor" v-model="params">
            <template>
            <el-button type="primary" @click="Filter">筛选</el-button>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
            </template>
        </pt-page-factor-filter> -->
        <pt-sample-recollect-table :tableLabel="tableLabels" class="pt-sample-recollect-table" ref="table" :pageSize="pageSize" :query-params="queryParams">
            <template>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detail(scope.row)">详情</el-button>
                        <el-button type="text" @click="sampleRecollect(scope.row)">重采</el-button>
                    </template>
                </el-table-column>
            </template>
        </pt-sample-recollect-table>
  </div>
</template>

<script>
// 组件class前缀
import { sampleRecollectFilterFactor, sampleRecollectTableLabel, sampleRecollectTabs } from '../goods-order-options'
import ptSampleRecollectTable from './pt-sample-recollect-table/withData'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-waiting-sample-recollect'
export default {
  name: 'pt-waiting-sample-recollect',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ptSampleRecollectTable
  },
  data () {
    return {
      sampleRecollectFilterFactor: sampleRecollectFilterFactor,
      params: {},
      tableLabels: sampleRecollectTableLabel,
      queryParams: {},
      tabs: sampleRecollectTabs,
      selectTab: null
    }
  },
  watch: {
    selectTab (val) {
      this.$set(this.queryParams, 'orderType', val)
    }
  },
  methods: {
    exportResampleOrder () {
      this.$emit('exportResampleOrder')
    },
    Filter () {
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'orderTime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.queryParams = { ...this.queryParams, ...this.params }
    },
    cleanParams () {
      emptyObject(this.params)
      this.queryParams = this.params
      this.Filter()
    },
    detail (val) {
      this.$router.push('/lab-order-detail/' + val.labOrderId)
    },
    sampleRecollect (val) {
      this.$router.push('/waiting-for-sample-recollect/sample-recollect-detail/' + val.sampleId + '/' + val.orderType)
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-sample-recollect-table{
    .el-button{
        margin-right: 10px;
        margin-left: 0
    }
}
</style>
